import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const todayIso = () => iso(new Date());
const daysAgoIso = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return iso(d); };
const monthStartIso = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`; };

export const PERIOD_RANGES = [
  { key: "today", label: "Hoje", range: () => [todayIso(), todayIso()] },
  { key: "7d", label: "7 dias", range: () => [daysAgoIso(6), todayIso()] },
  { key: "month", label: "Mês", range: () => [monthStartIso(), todayIso()] },
];

export function PeriodPicker({ preset, setPreset, from, to, setRange, testid = "hub-period" }) {
  const on = "bg-amber-brand hover:bg-amber-brandDark text-black font-bold";
  const off = "bg-zinc-900 border-zinc-800 text-zinc-200 hover:bg-zinc-800";
  return (
    <div data-testid={testid} className="rounded-2xl border border-card2-border bg-appbg-soft p-4 flex flex-wrap items-end gap-3">
      <div className="flex items-center gap-1 flex-wrap">
        {PERIOD_RANGES.map((r) => (
          <Button key={r.key} data-testid={`${testid}-${r.key}`} variant={preset === r.key ? "default" : "outline"}
            onClick={() => { setPreset(r.key); setRange(r.range()); }} className={preset === r.key ? on : off}>{r.label}</Button>
        ))}
      </div>
      <div>
        <Label className="text-xs font-mono-caps text-zinc-400">De</Label>
        <Input data-testid={`${testid}-from`} type="date" value={from} onChange={(e) => { setPreset("custom"); setRange([e.target.value, to]); }} className="mt-1 bg-zinc-900 border-zinc-800" />
      </div>
      <div>
        <Label className="text-xs font-mono-caps text-zinc-400">Até</Label>
        <Input data-testid={`${testid}-to`} type="date" value={to} onChange={(e) => { setPreset("custom"); setRange([from, e.target.value]); }} className="mt-1 bg-zinc-900 border-zinc-800" />
      </div>
    </div>
  );
}
